import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './CapabilityCard.css';

function CapabilityCard({ img, alt, title, linkText, sectionId }) {
  return (
    <div className="bg-white shadow-xl flex flex-col justify-between h-full group card-lift overflow-hidden">
      {/* Image Header Area */}
      <div className="h-52 overflow-hidden relative">
        <img
          src={img}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      </div>

      {/* Content Area */}
      <div className="p-7 flex-1 flex flex-col justify-between">
        <h3 className="text-2xl font-display font-bold text-cogCyan leading-snug">
          {title}
        </h3>

        {/* Dynamic Route Link targeting specific sectionId */}
        <Link
          to={`/services#${sectionId}`}
          className="link-arrow mt-6 text-blue-600 font-semibold text-base flex items-center space-x-1 hover:text-blue-800 transition-colors no-underline"
        >
          <span>{linkText}</span>
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}

export default CapabilityCard;